<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="20px"
    y="20px"
    viewBox="0 0 512 512"
    style="enable-background: new 0 0 512 512"
    xml:space="preserve"
    :width="size"
    :height="size"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M230.4,179.2h230.4v51.2H230.4V179.2z M230.4,281.6h179.2v51.2H230.4V281.6z M230.4,76.8H512V128H230.4V76.8z M230.4,384
		h128v51.2h-128V384z M76.8,460.8H128V153.6h76.8L102.4,51.2L0,153.6h76.8V460.8z"
      />
    </g>
  </svg>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export class IconASC extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;
}
export default IconASC;
</script>
